import { BreadCrumb } from "components/breadcrumb";
import { LanguageSwitcher } from "components/language-switcher/language-switcher";
import { RolesTypes } from "libs/models/login";
import { CROSSPAY_ROUTES } from "libs/routes";
import { connect, useSelector } from "react-redux";
import { UserAvatar } from "static/images/svgs/user-avatar";
import { CustomizedPush } from "store/navigation-wrapper";
import { getFileUrl } from "utils/mediaUrlFormater";
import { AppDispatch, ApplicationState } from "../../store";
import { setLocale } from "../../store/slices/ui";
import { TopNavigationBarProps } from "./top-navigation-bar.props";

const TopNavigationBar = (props: TopNavigationBarProps) => {
  const userLogo = useSelector(
    (state: ApplicationState) => state.login.loggedUser?.clientLogoId,
  );
  const userRole = useSelector(
    (state: ApplicationState) => state.login.userRole,
  );

  const openSettings = () => {
    CustomizedPush(CROSSPAY_ROUTES.SETTINGS);
  };

  const handleLanguageChange = (language: string) => {
    props.setLocale(language);
  };

  return (
    <div className="w-full h-full px-[32px] flex align-middle items-center justify-between">
      <BreadCrumb />

      <div className="flex text-end gap-1 align-middle items-center">
        <LanguageSwitcher onLanguageChange={handleLanguageChange} />
        {userRole !== RolesTypes.SuperAdmin && (
          <div className="dropdown relative">
            <button className="ms-[16px] h-10 w-10 rounded-[200px] flex items-center justify-center">
              <div className="flex justify-center">
                {userLogo ? (
                  <img
                    src={getFileUrl(userLogo)}
                    alt="user-avatar"
                    className="rounded-[200px] w-[40px] h-[40px] object-contain border-[1px] border-[#E1DEDD]"
                  />
                ) : (
                  <UserAvatar width={40} height={40} />
                )}
              </div>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
const mapStateToProps = (state: ApplicationState) => ({});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  setLocale: (language: string) => {
    dispatch(setLocale(language));
  },
});

const TopNavigationBarContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TopNavigationBar);
export { TopNavigationBarContainer };
